import { action } from 'typesafe-actions';
import {
  IBilledByDayData,
  IBilledMonthData,
  IDuplicateData,
  IDuplicatesByDayData,
  IOpenOrderStatusData,
  IOpenOrderStatusDataBySku,
  IPaidByMonthData,
  Types
} from './types';
import moment from 'moment';
import { ECustomerTypeView } from '../user/types';

export const loadOpenOrderStatus = (
  selectedCustomerId: string,
  customerType: ECustomerTypeView
) => action(Types.LOAD_OPEN_ORDER_STATUS, { selectedCustomerId, customerType });
export const loadOpenOrderStatusSuccess = (
  openOrderStatus: IOpenOrderStatusData[],
  lastUpdateMoment: moment.Moment
) =>
  action(Types.LOAD_OPEN_ORDER_STATUS_SUCCESS, {
    openOrderStatus,
    lastUpdateMoment
  });
export const loadOpenOrderStatusFailure = (error: unknown) =>
  action(Types.LOAD_OPEN_ORDER_STATUS_FAILURE, { error });

export const loadOpenOrderStatusBySku = (
  selectedCustomerId: string,
  customerType: ECustomerTypeView
) =>
  action(Types.LOAD_OPEN_ORDER_STATUS_BY_SKU, {
    selectedCustomerId,
    customerType
  });
export const loadOpenOrderStatusBySkuSuccess = (
  openOrderStatusBySku: IOpenOrderStatusDataBySku[],
  lastUpdateMoment: moment.Moment
) =>
  action(Types.LOAD_OPEN_ORDER_STATUS_BY_SKU_SUCCESS, {
    openOrderStatusBySku,
    lastUpdateMoment
  });
export const loadOpenOrderStatusBySkuFailure = (error: unknown) =>
  action(Types.LOAD_OPEN_ORDER_STATUS_BY_SKU_FAILURE, { error });

export const loadBilledByMonth = (
  selectedCustomerId: string,
  customerType: ECustomerTypeView
) => action(Types.LOAD_BILLED_BY_MONTH, { selectedCustomerId, customerType });
export const loadBilledByMonthSuccess = (billedMonthData: IBilledMonthData[]) =>
  action(Types.LOAD_BILLED_BY_MONTH_SUCCESS, { billedMonthData });
export const loadBilledByMonthFailure = (error: unknown) =>
  action(Types.LOAD_BILLED_BY_MONTH_FAILURE, { error });

export const loadPaidByMonth = (
  selectedCustomerId: string,
  customerType: ECustomerTypeView
) => action(Types.LOAD_PAID_BY_MONTH, { selectedCustomerId, customerType });
export const loadPaidByMonthSuccess = (paidMonthData: IPaidByMonthData[]) =>
  action(Types.LOAD_PAID_BY_MONTH_SUCCESS, { paidMonthData });
export const loadPaidByMonthFailure = (error: unknown) =>
  action(Types.LOAD_PAID_BY_MONTH_FAILURE, { error });

export const loadDuplicates = (
  selectedCustomerId: string,
  customerType: ECustomerTypeView
) => action(Types.LOAD_DUPLICATES, { selectedCustomerId, customerType });
export const loadDuplicatesSuccess = (invoicesSummary: IDuplicateData) =>
  action(Types.LOAD_DUPLICATES_SUCCESS, { invoicesSummary });
export const loadDuplicatesFailure = (error: unknown) =>
  action(Types.LOAD_DUPLICATES_FAILURE, { error });

export const loadBilledByDay = (
  selectedCustomerId: string,
  customerType: ECustomerTypeView,
  billedByDayMonthDate?: moment.Moment
) =>
  action(Types.LOAD_BILLED_BY_DAY, {
    selectedCustomerId,
    billedByDayMonthDate,
    customerType
  });
export const loadBilledByDaySuccess = (billedByDayData: IBilledByDayData[]) =>
  action(Types.LOAD_BILLED_BY_DAY_SUCCESS, { billedByDayData });
export const loadBilledByDayFailure = (error: unknown) =>
  action(Types.LOAD_BILLED_BY_DAY_FAILURE, { error });

export const loadDuplicatesByDay = (
  selectedCustomerId: string,
  customerType: ECustomerTypeView,
  duplicatesByDayMonthDate?: moment.Moment
) =>
  action(Types.LOAD_DUPLICATES_BY_DAY, {
    selectedCustomerId,
    duplicatesByDayMonthDate,
    customerType
  });
export const loadDuplicatesByDaySuccess = (
  duplicatesByDayData: IDuplicatesByDayData[]
) => action(Types.LOAD_DUPLICATES_BY_DAY_SUCCESS, { duplicatesByDayData });
export const loadDuplicatesByDayFailure = (error: unknown) =>
  action(Types.LOAD_DUPLICATES_BY_DAY_FAILURE, { error });

export const cleanDashboard = () => action(Types.CLEAN_DASHBOARD);
